import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Button, SquareButton } from '@app/core';
import gif from './assets/calendar-demo.gif';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'absolute',
    left: theme.marginBase * 3,
    bottom: theme.marginBase * 3,
    zIndex: 100,

    backgroundColor: theme.colors.white,
    boxShadow: theme.boxShadow.base,
    padding: theme.marginBase * 3,
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    marginBottom: theme.marginBase * 2,
  },
  title: {
    ...theme.fonts.h4,
  },
  closeButton: {},
  gif: {
    width: 400,
  },
  content: {
    ...theme.fonts.caption,
    whiteSpace: 'pre-wrap',
    maxWidth: 400,
  },
  learnMore: {
    textAlign: 'right',
    marginTop: theme.marginBase * 2,
  },
}));

const LOCAL_STORAGE_DISSMISS_KEY = 'calendar-announcement-dissmiss';

export const CalendarAnnoncement = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const defaultValue = !localStorage.getItem(LOCAL_STORAGE_DISSMISS_KEY);

  const [isOpen, setIsOpen] = React.useState(defaultValue);
  const close = React.useCallback(() => {
    setIsOpen(false);
    localStorage.setItem(LOCAL_STORAGE_DISSMISS_KEY, 'true');
  }, [setIsOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.head}>
        <h3 className={classes.title}>{t('calendar.annoncement.title')}</h3>
        <SquareButton
          className={classes.closeButton}
          onClick={close}
          icon="ri-close-line"
          color="ink"
        />
      </div>
      <img src={gif} alt="calendar demo" className={classes.gif} />

      <p className={classes.content}>{t('calendar.annoncement.content')}</p>
      <div className={classes.learnMore}>
        <Button
          color="blue"
          variant="transparent"
          href={
            i18n.language === 'fr'
              ? 'https://tandemz.crisp.help/fr/article/comment-gerer-mes-disponibilites-pour-ma-session-y2aet/'
              : 'https://tandemz.crisp.help/en/article/how-do-i-manage-my-availabilities-for-my-session-1jthb4e/'
          }
          target="_blank"
        >
          {t('calendar.annoncement.help')}
        </Button>
      </div>
    </div>
  );
};
